import { StyleSheet } from 'react-native';
import { brand } from 'src/theme/colors';
import { Neutrals } from 'src/theme-v2/colors';
import { textLatoStyleDS } from 'src/theme-v2/text';
import { Spacing } from 'src/theme-v2/spacing';

export const style = StyleSheet.create({
  qualityIcon: {
    width: 100,
    height: 100,
  },
  description: {
    ...textLatoStyleDS.BodyRegularMd,
    textAlign: 'center',
    color: Neutrals.neutralGreys.GreyNatural850,
  },
  subDescription: {
    ...textLatoStyleDS.BodyBoldMd,
    textAlign: 'center',
    color: Neutrals.neutralGreys.GreyNatural850,
  },
  descriptionContainer: {
    gap: Spacing.Compact,
    alignItems: 'center',
  },
  qualityIconMain: {
    width: 40,
    height: 40,
    backgroundColor: brand.main.mustard,
    borderRadius: 100,
    paddingHorizontal: 5,
    paddingVertical: 3,
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: 26,
    height: 26,
  },
});
